<template>
    <form @submit.prevent="emitSubmit">
        <div class="row">
            <div v-if="showMailInput" class="small-12 columns" :class="{ error: showMailErrorText }">
                <label>
                    E-Mail Adresse, die geprüft werden soll
                    <div class="hint-text">
                        Gültige E-Mail Adresse eingeben, Beispiel: maxmustermann@muster.de
                    </div>
                    <input type="text" :disabled="disabled" v-model="formData.mail"/>
                </label>
                <small class="error" v-if="showMailErrorText">
                    {{ mailErrorText }}
                </small>
            </div>
            <div v-if="showPhoneInput" class="small-12 columns" :class="{ error: showPhoneErrorText }">
                <label>
                    Telefonnummer, die geprüft werden soll
                    <div class="hint-text">
                        Telefonnummer im nationalen Format (ohne Leerzeichen und Ländervorwahl als 0) eingeben, Beispiel: 08519861300
                    </div>
                    <input type="text" :disabled="disabled" v-model="formData.phone"/>
                </label>
                <small class="error" v-if="showPhoneErrorText">
                    {{ phoneErrorText }}
                </small>
            </div>
        </div>
    </form>
</template>

<script>
import TypeHelper from '../helper/TypeHelper';
import Validation from '../helper/Validation';
import Modes from '../constants/Modes';

export default {
    name: 'DataLeaksForm',
    props: {
        mode: Number,
        disabled: Boolean
    },
    data: () => ({
        formData: {
            phone:  null,
            mail:   null
        },
        validation: {
            isFormDirty:    false,
            isPhoneDirty:   false,
            isMailDirty:    false
        }
    }),
    computed: {
        showPhoneErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isPhoneDirty)
                && TypeHelper.isNotNullOrUndefined(this.phoneErrorText);
        },
        showMailErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMailDirty)
                && TypeHelper.isNotNullOrUndefined(this.mailErrorText);
        },
        phoneErrorText()
        {
            let validators = [];
            if (this.showPhoneInput)
                validators.push(Validation.isNotNull, Validation.isNationalPhone);

            return Validation.runValidation(this.formData.phone, validators);
        },
        mailErrorText()
        {
            let validators = [];
            if (this.showMailInput)
                validators.push(Validation.isNotNull, Validation.isEmail);

            return Validation.runValidation(this.formData.mail, validators);
        },
        showPhoneInput()
        {
            return this.mode === Modes.PHONE || this.mode === Modes.BOTH;
        },
        showMailInput()
        {
            return this.mode === Modes.EMAIL || this.mode === Modes.BOTH;
        }
    },
    methods: {
        validateForm()
        {
            this.validation.isFormDirty = true;

            this.emitValidity();
        },
        emitValidity()
        {
            this.$emit('updateValidity', this.isFormValid());
        },
        emitSubmit()
        {
            this.$emit('submitForm');
        },
        isFormValid()
        {
            let isValid = true;
            isValid = isValid && (this.phoneErrorText === null);
            isValid = isValid && (this.mailErrorText === null);

            return isValid;
        },
        emitChangedFormData()
        {
            this.$emit('changeFormData', this.formData);
        }
    },
    watch: {
        mode()
        {
            this.formData.mail = null;
            this.formData.phone = null;
            this.validation.isMailDirty = false;
            this.validation.isPhoneDirty = false;

            this.emitValidity();
        },
        'formData.phone': function()
        {
            this.validation.isPhoneDirty = true;
        },
        'formData.mail': function()
        {
            this.validation.isMailDirty = true;
        },
        formData: {
            handler: function()
            {
                this.emitChangedFormData();
                this.emitValidity();
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.error label {
    color: #4d4d4d;
}
select {
    margin: 0 0 1rem;
}

.error select {
    margin-bottom: 0;
}

.hint input {
    margin-bottom: 0;
}

.hint-text {
    color: grey;
    font-size: 0.75rem;
}
</style>
